module.exports = __webpack_public_path__ + "img/bank-08-kbank.94cf2dfc.svg";